import { render, staticRenderFns } from "./MomentsAgo.vue?vue&type=template&id=93bf6ef6&scoped=true&"
import script from "./MomentsAgo.vue?vue&type=script&lang=js&"
export * from "./MomentsAgo.vue?vue&type=script&lang=js&"
import style0 from "./MomentsAgo.vue?vue&type=style&index=0&id=93bf6ef6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bf6ef6",
  null
  
)

export default component.exports